import { PostProperties } from "../types";
import image from "../img/lostGemConvextion.jpg";

const post: PostProperties = {
  id: 31,
  title: "Convextion - 220V, Eindhoven (01.03.2007) ",
  content: `Gerard Hanson, better known by his stage monikers Convextion or E.R.P. (Event Related Potential), is renowned for his deep, atmospheric techno and electro productions. Coming from Dallas, Texas, Convextion has become household name known for his unique Detroit and minimalistic approach to productions. This rare and obscure recording made in Eindhoven, Netherlands showcases why Convextion is undoubtedly one of the most authentic electro artists out there.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/convextion-220v-eindhoven-01",
  category: "Lost Gem",
  translationsBg: {
    content: `Джерард Хансън, по-известен със сценичните си псевдоними Convextion или E.R.P. (Event Related Potential), е известен със своите дълбоки, атмосферни техно и електро продукции. Convextion, роден в Далас, Тексас, се е превърнал в име, известно с уникалния си подход към продукцията, характерен за Детройт, и минималистичен стил. Този рядък и необичаен запис, направен в Айндховен, Холандия, показва защо Convextion несъмнено е един от най-автентичните електро изпълнители.`,
  },
};

export default post;
